import { configureStore } from '@reduxjs/toolkit';
import { backendApi } from './backendApi';
import errorReducer from './errorSlice';

const apiStore = configureStore({
  reducer: {
    [backendApi.reducerPath]: backendApi.reducer,
    error: errorReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(backendApi.middleware),
});

export default apiStore;

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof apiStore.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof apiStore.dispatch;
